<script setup>
import { computed, ref } from "vue";

const props = defineProps(["timeslots", "modelValue"]);
defineEmits(["update:modelValue"]);

const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang, { hour: "numeric", minute: "numeric" });

const date = ref(null);

const activeDates = computed(() => {
	const dates = {};

	for (const ts of props.timeslots) {
		const key = tsToDate(ts.start);

		if (key in dates)
			dates[key].push(ts.start);
		else
			dates[key] = [ts.start];
	}

	return dates;
});

const dayTimeslots = computed(() => {
	if (!Number.isFinite(date.value))
		return [];

	return activeDates.value[tsToDate(date.value)] || [];
});

function tsToDate(ts) {
	const d = new Date(ts * 1000);

	return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}

if (Number.isFinite(props.modelValue))
	date.value = props.modelValue;
else if (props.timeslots.length > 0)
	date.value = props.timeslots[0].start;
</script>

<template>
	<div class="vui-date-time-picker grid gap-12">
		<UiDatePicker
			v-model="date"
			:active-dates="activeDates"
		/>
		<slot></slot>
		<div class="time-picker grid gap-8">
			<UiRadioButton
				v-for="ts in dayTimeslots"
				:key="ts"
				name="ts"
				class="vui-radio-custom"
				:label="dateFormat.format(ts * 1000)"
				:model-value="modelValue"
				:value="ts"
				@update:model-value="$emit('update:modelValue', $event)"
			/>
			<div v-if="date !== null && dayTimeslots.length === 0" class="justify-self-center">{{ $gettext("There are currently no available appointments for this date.") }}</div>
		</div>
	</div>
</template>
